export const primaryColor = "#2f7a56"
export const spainColor = "#F1BF00"
export const greeceColor = "#001489"
export const italyColor = "#008C45"

export const rateButtonColor = "#6ab165"